import { Box, Icon } from '@alto-avios/alto-ui'
import classNames from 'classnames'
import { useComboboxOption } from './AutoComplete'
import styles from './AutoCompleteLocationOption.module.scss'
import { LocationOptionProps } from './AutoComplete.types'

type Props = {
  item: LocationOptionProps
  index: number
}

export const AutoCompleteLocationOption = ({ item, index }: Props) => {
  const option = useComboboxOption(item, index)
  const { value, icon, title, subtitle } = item
  const hasIcon = !!icon

  return (
    <li
      className={classNames(
        styles.locationOptionWrapper,
        !hasIcon && styles.locationOptionNoIconWrapper
      )}
      {...option.props}
      data-highlighted={option.isHighlighted}
      data-testid={`${value}-option`}
    >
      {hasIcon && <Icon {...icon} iconSize="sm" className={styles.autoCompleteListIcon} />}
      <Box paddingY={2} display="flex" flexDirection="column">
        <p className={styles.autoCompleteListTitle}>{title}</p>
        <p className={styles.autoCompleteListP}>{subtitle}</p>
      </Box>
    </li>
  )
}
